/* INTEGRATIONS */
export const EXTERNAL_INTEGRATIONS = '/api/datintell/v1/external_integrations/';
export const GET_INTEGRATION_LINK = (provider: string, id = '') => {
  const integrationId = id ? `${id}/` : '';
  return `/api/${provider}/v1/integrations/${integrationId}`;
};
export const GET_INTEGRATION_LINK_V2 = (provider: string, id = '') => {
  const integrationId = id ? `${id}/` : '';
  return `/api/${provider}/v2/integrations/${integrationId}`;
};
export const GET_GA4_INTEGRATION_LINK = (id = '') => {
  const integrationId = id ? `${id}/` : '';
  return `/api/ga4-service/integrations/${integrationId}`;
};

export const GET_GA4_OAUTH_UPDATE_INTEGRATION_LINK = (id = '') => {
  const integrationId = id ? `${id}/` : '';
  return `/api/ga4-service/integrations/oauth_update_integration/${integrationId}`;
};

export const CAMPAIGN_MANAGER_USERS =
  '/api/campaign_manager/external_user_profiles/';
export const CAMPAIGN_MANAGER_ADVERTISERS =
  '/api/campaign_manager/external_advertisers/';

export const ADFORM_ADVERTISERS = '/api/adform/external_advertisers/';
